import React from "react";
import { ButtonDS, Typography } from "get-life-storybook-ts";
import { LegalNoteRejectionI, legalNoteRejectionTexts } from "./legalNoteRejection";

interface LegalNoteRejectionDialogPropsI {
  rejection: LegalNoteRejectionI;
  translate: (key: string) => string;
  onClose: () => void;
}

/**
 * Aviso tras el 409 de accept-legal-note: la nota legal NO se ha aceptado y el
 * cliente se queda en /payment/4 (sin navegar a /waitingvalidation). Mismo patrón
 * de diálogo que ProposalFailureDialog.
 */
const LegalNoteRejectionDialog = ({
  rejection,
  translate,
  onClose,
}: LegalNoteRejectionDialogPropsI) => {
  const { title, message, close } = legalNoteRejectionTexts(translate, rejection);

  return (
    <div className="checkoutPay__backdrop">
      <div
        role="alertdialog"
        aria-modal="true"
        aria-labelledby="legal-note-rejection-title"
        data-testid="legal-note-rejection"
        className="checkoutPay__dialog"
      >
        <div className="checkoutPay__dialogText">
          <span id="legal-note-rejection-title">
            <Typography text={title} variant="H3" weight="700" className="text-[#424242]" />
          </span>
          <Typography text={message} variant="BodyMedium" weight="400" />
        </div>
        <div className="checkoutPay__dialogButtons">
          <ButtonDS label={close} onClick={onClose} className="w-full" />
        </div>
      </div>
    </div>
  );
};

export default LegalNoteRejectionDialog;
